import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/yacht-types', data)
    .then(response => {
      return response.data
    })
}

function update(data, id) {
  return axios.patch(`/yacht-types/${id}`, data)
    .then(response => {
      return response.data
    })
}

export default {
  fetch(params) {
    return axios.get('/yacht-types', { params: params })
      .then(response => {
        return response.data
      })
  },
  save(data, id) {
    return id ? update(data, id) : store(data)
  },
  updateCosts(data) {
    return axios.post('/yacht-type-costs', data).then(response => response.data)
  }
}
